/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert_circle': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zm2.234-83.74L106 91.34c1.639 2.733.643 4.463-2.578 4.463H46.576c-3.214 0-4.213-1.73-2.575-4.462l28.267-47.08c1.65-2.751 3.814-2.751 5.466 0zm-36.52 45.45C38.298 94.573 40.85 99 46.576 99h56.846c5.729 0 8.282-4.425 5.362-9.29L80.52 42.632c-2.907-4.84-8.133-4.843-11.04 0l-28.267 47.08zM73 77.4c0 .884.67 1.6 1.5 1.6s1.5-.716 1.5-1.6V55.6c0-.884-.67-1.6-1.5-1.6s-1.5.716-1.5 1.6v21.8zm0 11c0 .884.67 1.6 1.5 1.6s1.5-.716 1.5-1.6v-4.8c0-.884-.67-1.6-1.5-1.6s-1.5.716-1.5 1.6v4.8z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
